module.exports = __webpack_public_path__ + "img/computer5.46105a62.gif";